import React, { useState } from "react";
import InputMask from "react-input-mask";

const generateTimeOptions = () => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    times.push(
      `${String(hour).padStart(2, "0")}:00`,
      `${String(hour).padStart(2, "0")}:30`
    );
  }
  return times;
};

const TimeInput = ({ value, handleTimeChange, disabled = false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const timeOptions = generateTimeOptions();

  const handleDropdownSelect = (time) => {
    handleTimeChange({ target: { value: time } });
    setShowDropdown(false);
  };

  const handleFocus = () => {
    if (!disabled) setShowDropdown(true);
  };

  const handleBlur = () => {
    // Delay hiding dropdown to allow click on option
    setTimeout(() => setShowDropdown(false), 100);
  };

  return (
    <span style={{ position: "relative" }}>
      {!disabled ? (
        <>
          <InputMask
            mask="99:99" // Mask format for HH:MM
            value={value}
            onChange={handleTimeChange}
            disabled={disabled}
            placeholder="__:__"
            onFocus={handleFocus}
            onBlur={handleBlur}
            className="schedule-input -time"
          >
            {(inputProps) => <input {...inputProps} type="text" id="time" />}
          </InputMask>

          {showDropdown && !disabled && (
            <div className="time-dropdown">
              {timeOptions.map((time) => (
                <div
                  key={time}
                  onMouseDown={() => handleDropdownSelect(time)}
                  className="time-option"
                >
                  {time}
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div className="schedule-input disabled-office-hours-input">
          {value}
        </div>
      )}
    </span>
  );
};

export default TimeInput;
